module.exports = __webpack_public_path__ + "img/failRegister.e9c47c33.e9c47c33.svg";